import { useMutation} from '@tanstack/react-query';
import {
    agentRole,
  UserApiService,
} from 'features/users/api/user-api.service';



const { saveagentRoleByIdPermissions } = UserApiService();

export const useCreateUserAgentRoleBYId = () => {

  return useMutation(
    (payload: agentRole) => {
      return saveagentRoleByIdPermissions(payload);
    },
  );
};





